import React from "react";
import styled from "styled-components";
import FacebookIcon from "@material-ui/icons/Facebook";
import GithubIcon from "@material-ui/icons/GitHub";
import YoutubeIcon from "@material-ui/icons/YouTube";
// import Particle from '../Components/Particle';

function HomePage() {
  return (
    <HomePageStyled>
      <div className="particle-con">{/* <Particle /> */}</div>
      <div className="typography">
        <h1>
          Hallo, Saya seorang <span>Fullstack Web Developer</span>
        </h1>
        <p>
          Saya <span>Bagus Fatwan Alfiat</span> lulusan Sarjana Teknik Informatika di salah satu
          Universitas swasta yang berfokus pada Web Developer. Saat ini saya menekunin sebagai Fullstack Developer dan memiliki
          pengalaman sebagai freelancer dalam mengembangkan sistem dari beberapa
          instansi Pemerintahan Indonesia atau non-pemerintah berbasis web.
          Cepat dalam mempelajari teknologi baru, pekerja keras, dan memiliki
          kemampuan pemecahan masalah yang cukup.
        </p>
        <div className="icons">
          <a href="https://facebook.com/sikece.haha/" className="icon i-facebook">
            <FacebookIcon />
          </a>
          <a href="https://github.com/gusfat99" className="icon i-github">
            <GithubIcon />
          </a>
          {/* <a href="https://codepen.io/pen/" className="icon i-youtube">
            <YoutubeIcon />
          </a> */}
        </div>
      </div>
    </HomePageStyled>
  );
}

const HomePageStyled = styled.header`
  width: 100%;
  height: 100vh;
  position: relative;

  .typography {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 80%;

    .icons {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      .icon {
        border: 2px solid var(--border-color);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.4s ease-in-out;
        cursor: pointer;
        &:hover {
          border: 2px solid var(--primary-color);
          color: var(--primary-color);
        }
        &:not(:last-child) {
          margin-right: 1rem;
        }
        svg {
          margin: 0.5rem;
        }
      }

      .i-youtube {
        &:hover {
          border: 2px solid red;
          color: red;
        }
      }
      .i-github {
        &:hover {
          border: 2px solid #5f4687;
          color: #5f4687;
        }
      }
    }
    .p span {
        color: var(--primary-color);
    }
  }
`;

export default HomePage;
